export default __webpack_public_path__ + "media/flags/gi-51e90a70.svg";